import { fromJS } from 'immutable';
import R, { isEmpty, contains } from 'ramda';
import * as contractingCnts from '../../../components/contracting/__storeFiles__/constants';

const isNilOrEmpty = R.either(R.isNil, R.isEmpty);
const initialState = fromJS({
  leftNav: {
    isLatest: true,
  },
  notes: [],
  activities: {},
  rightSideContent: {},
  draftErrors: {},
  changeLogs: [],
  loadingLogs: false,
  showAllDraftErrorsDialog: false,
  showDraftChangesPopover: {
    open: false,
    anchorEl: null,
  },
  contentLoading: false,
  leftNavLoading: false,
  createDraftDialogOpen: false,
});

function contractActivitiesProducts(state = initialState, { type, payload, args }) {
  switch (type) {
    case '[contractTemplate]TOGGLE_CREATE_DRAFT_DIALOG':
      return state.set('createDraftDialogOpen', !state.get('createDraftDialogOpen'));
    case 'TOGGLE_DRAFT_ERRORS_DIALOG':
      return state.set('showAllDraftErrorsDialog', !state.get('showAllDraftErrorsDialog'));
    case 'TOGGLE_SHOW_DRAFT_CHANGES_POPOVER':
      return state.set('showDraftChangesPopover', fromJS(payload));
    case `${'GET_DIFF_SUMMARY_FOR_DRAFT'}_STARTED`:
      return state.setIn(['leftNav', 'diffSummary', 'loading'], true);
    case `${'GET_DIFF_SUMMARY_FOR_DRAFT'}_SUCCESS`:
      return state.setIn(['leftNav', 'diffSummary'], fromJS({
        ratesSummary: payload.ratesSummary,
        summaryByPage: payload.rawDiffData,
      }));
    case '[contracting-download]ACCEPT_RATES_SUCCESS':
      return state.setIn(['leftNav', 'contractState'], 'accepted')
        .setIn(['leftNav', 'state'], 'accepted');
    case `${'GET_DIFF_SUMMARY_FOR_DRAFT'}_ERROR`:
      return state.setIn(['leftNav', 'diffSummary', 'loading'], false);
    case contractingCnts.REFRESH_STARTED:
      return state.set('refreshing', true);
    case contractingCnts.REFRESH_FINISHED:
      return state.set('refreshing', false);
    case `${contractingCnts.REFRESH_COMPLETION_CHECK}_SUCCESS`:
    case '[template-draft]CHECK_COMPLETENESS_FOR_TEMPLATE_DRAFT':
      return state.set('draftErrors', fromJS(payload.errors));
    case 'ADD_CONTRACT_FILES':
      return state.updateIn(['leftNav', 'files'], files => files.concat(fromJS(payload.files)))
        .updateIn(['rightSideContent', 'files'], files => files.concat(fromJS(payload.files)));
    case 'CONTRACT_FILES_MODIFIED':
      return state.setIn(['leftNav', 'files'], fromJS(payload.files))
        .setIn(['rightSideContent', 'files'], fromJS(payload.files))
        .setIn(['leftNav', 'buyerChecked'], payload.files.length ? true : state.getIn(['leftNav', 'buyerChecked']));
    case 'REMOVE_INSURANCE_FILE':
      return state.updateIn(['rightSideContent', 'billingInformation', 'insuranceFiles'], insuranceFiles => {
        if (!insuranceFiles) return insuranceFiles;
        return fromJS([]);
      });
    case 'PARTNER_CHECK_AFTER_REVIEW':
      return state.update('leftNav', leftNav => leftNav.merge(fromJS(payload)));
    case 'DELETE_PRODUCT_FROM_CONTRACT_START':
    case 'DISCARD_EDITED_CONTRACT_DRAFT_STARTING':
    case 'CONTRACT_CONTENT_LOADING':
      return state.set('contentLoading', true);
    case 'CONTRACT_LEFT_NAV_LOADING':
      return state.set('leftNavLoading', true);
    case 'GET_CONTRACT_INFO_ERROR':
      return state.set('errorOccurs', payload.errorOccurs)
        .set('contentLoading', false)
        .set('leftNavLoading', false);
    case 'DISCARD_EDITED_CONTRACT_DRAFT_FAILED':
      return state.set('contentLoading', false);
    case `${contractingCnts.REFRESH_LEFT_NAV}_SUCCESS`:
      return state.update(
        'leftNav',
        leftNav => leftNav.merge(fromJS({
          ...payload,
          contractId: args[0].docId,
          collection: args[0].collection,
        })),
      );
    case 'GET_CONTRACT_LEFT_NAV':
      return state.set('leftNav', fromJS(payload))
        .set('leftNavLoading', false);
    case '[contract-request]GET_RESPONDED_CONTRACT_LIST_SUCCESS':
      return state.update('leftNav', leftNav => leftNav.merge(fromJS({
        respondedContractList: payload.list,
        respondedContracts: payload.list.map(o => o._id),
        respondedLocIds: payload.list.map(o => o.locationId),
      })));
    case '[draft-template]GET_SENT_PARTNERS_SUCCESS':
      return state.setIn(['leftNav', 'sentPartners'], fromJS(payload.list));
    case `${contractingCnts.REFRESH_POLICIES_NOTES}_SUCCESS`:
      return state.update(
        'rightSideContent',
        content => content.merge(fromJS(payload))
      );
    case 'GET_CONTRACT_DETAILS':
      return state.set('rightSideContent', fromJS(payload))
        .set('routeName', 'contractDetails')
        .set('contentLoading', false);
    case 'LOADING_HISTORY_FEEDS':
      return state.set('contentLoading', true);
    case 'GET_HISTORY_FEEDS':
      return state.set('activities', fromJS(payload.response))
        .set('routeName', 'activities')
        .set('contentLoading', false);
    case `${contractingCnts.GET_NOTES}_SUCCESS`:
      return state.set('notes', fromJS(payload));
    case `${contractingCnts.REFRESH_PRODUCT_DETAILS}_SUCCESS`:
      return state.update(
        'rightSideContent',
        content => content.merge(fromJS(payload.product))
      );
    case 'GET_PRODUCT_DETAILS':
      return state.set('rightSideContent', fromJS(payload.product))
        .set('routeName', 'product')
        .set('contentLoading', false);
    case 'CHANGE_CONTRACT_STATE_STARTING':
      if (payload.state === 'accepted' || payload.state === 'loaded') {
        return state.update('leftNav', leftNav => {
          if (!leftNav) return leftNav;
          if (contains(leftNav.get('contractId'), Object.keys(payload.contractIds))) {
            return leftNav.merge(fromJS({
              contractState: payload.state,
              state: payload.state,
              buyerChecked: true,
            }));
          }
          return leftNav;
        });
      }
      if (payload.state === 'received externally' || payload.state === 'received') {
        return state.setIn(['leftNav', 'buyerChecked'], true)
          .setIn(['leftNav', 'state'], 'pending')
          .setIn(['leftNav', 'contractState'], 'pending');
      }
      if (payload.state === 'sent') {
        return state.setIn(['leftNav', 'buyerChecked'], false)
          .setIn(['leftNav', 'state'], 'pending')
          .setIn(['leftNav', 'contractState'], 'pending');
      }
      return state.setIn(['leftNav', 'contractState'], payload.state)
        .setIn(['leftNav', 'state'], payload.state);
    case 'SUBMIT_CONTRACTING_COMMENT':
      return state
        .updateIn(
          ['activities', 'messageArray'],
          messages => messages.unshift({ ...payload, isLoading: true })
        );
    case 'SUBMIT_CONTRACTING_COMMENT_SUCCESS':
      return state
        .updateIn(
          ['activities', 'messageArray'],
          messages => messages.set((messages.size - 1), { ...payload.comment, isLoading: false })
        );
    // .updateIn(
    //   ['historyFeedToShow', 'filesArray'],
    //   filesArray => filesArray ? filesArray.concat(payload.files) : filesArray
    // );
    case 'CHECK_ONE_PRODUCT_IN_ADD_PRODUCT_WIZARD':
      if (isEmpty(state.get('rightSideContent').toJS())) return state;
      return state.setIn(['leftNav', 'allContractingReadyProducts', payload.index, 'checked'], payload.checked);
    // case 'HISTORY_FEEDS_VIEWED':
    //   return state.updateIn(['rightSideContent', 'messageArray'], messageArray => {
    //     if (!messageArray) return messageArray;
    //     return messageArray.map(message => {
    //       if (message.get('_id')) return message.merge(fromJS(payload.updatedHistoryFeedsMap[message.get('_id')]));
    //       return message;
    //     });
    //   });
    case 'UPDATE_BUYER_INFO':
      return state.setIn(['rightSideContent', 'buyerInfo', payload.data.fieldName], payload.data.value);
    /*
    * Becoming draft - remember to update contract list too(dashboard-reducer)
    * */
    case 'PRODUCTS_SORTED_IN_CONTRACT':
      return state.setIn(['leftNav', 'productsArray'], fromJS(payload.products));
    case 'DELETE_PRODUCT_FROM_CONTRACT':
      return state.set('rightSideContent', fromJS({ seasons: [] }))
        .set('contentLoading', false)
        .set('draftErrors', isNilOrEmpty(payload.errors) ? state.get('draftErrors') : fromJS(payload.errors));
    case 'PRODUCTS_SAVED_UPDATE_REDUX':
      return state.set('draftErrors', isNilOrEmpty(payload.errors) ? state.get('draftErrors') : fromJS(payload.errors));
    case 'SAVE_BILLING_INFO_ADD_EDIT':
      const updatedData = {
        ...payload.data,
        insuranceFiles: payload.data.insuranceFiles.map(file => ({ fileName: file.name || file.fileName, downloadUrl: file.downloadUrl })),
      };
      return state.setIn(['rightSideContent', 'billingInformation'], fromJS(updatedData))
        .setIn(['rightSideContent', 'sameAsCorporatePolicyNotes'], fromJS(payload.sameAsCorporatePolicyNotes))
        .updateIn(['leftNav', 'editHistory'], histories => histories.push(fromJS({ detail: 'Edit Billing Info' })))
        .set('draftErrors', isNilOrEmpty(payload.errors) ? state.get('draftErrors') : fromJS(payload.errors));
    case 'CONTRACT_SUPPLIER_DETAIL_UPDATED':
      return state.update('rightSideContent', detail => detail.merge(fromJS(payload.contractDetails)))
        .update('leftNav', leftNav => leftNav.merge(fromJS(payload.contractDetails)))
        .updateIn(['leftNav', 'editHistory'], histories => histories ? histories.push(fromJS({ detail: R.pathOr('', ['editHistory', 'detail'], payload) })) : histories)
        .set('draftErrors', isNilOrEmpty(payload.errors) ? state.get('draftErrors') : fromJS(payload.errors));
    case '[contract-product]CREATE_RATE_PACKAGE_SUCCESS':
      return state.set('draftErrors', isNilOrEmpty(payload.errors) ? state.get('draftErrors') : fromJS(payload.errors));
    case 'CONTRACT_PRODUCT_UPDATED':
      return state.update('rightSideContent', product => product.merge(fromJS(payload.product)))
        .updateIn(['leftNav', 'editHistory'], histories => {
          if (payload.syncSection) {
            return histories.concat(state.getIn(['leftNav', 'productsArray']).map(product => fromJS({
              productId: product.get('productId'),
              ratePackageName: product.get('ratePackageName'),
              detail: payload.editHistory.detail,
            })));
          }
          return histories.push(fromJS(payload.editHistory));
        })
        .set('draftErrors', isNilOrEmpty(payload.errors) ? state.get('draftErrors') : fromJS(payload.errors));
    case 'ON_CHECK_SYNC_SECTION_IN_CONTRACT_TEMPLATE_DRAFT':
      return state.updateIn(['leftNav', 'syncedSections'], syncedSections => {
        if (!syncedSections) return fromJS([payload.sectionInEdit]);
        if (!payload.checked) return syncedSections.filter(section => section !== payload.sectionInEdit);
        return syncedSections.push(payload.sectionInEdit);
      });
    case 'CLEAR_CONTRACT_ACTIVITY_PRODUCT_REDUCER':
      return initialState;
    case '[contract-template]GET_CHANGE_LOGS_STARTED':
      return state.set('loadingLogs', true);
    case '[contract-template]GET_CHANGE_LOGS_SUCCESS':
      return state.set('loadingLogs', false)
        .set('changeLogs', fromJS(payload));
    case '[contract-template]GET_CHANGE_LOGS_ERROR':
      return state.set('loadingLogs', false);
    case '{dummy-account} DISCARD_DUMMY_TEMPLATE_DRAFT_SUCCESS':
      return state.setIn(['leftNav', 'buyerHasDraftId'], null);
    default:
      return state;
  }
}

export default contractActivitiesProducts;



// WEBPACK FOOTER //
// ./src/app/stores/contracting/contract-activities-products/contract-activities-products-reducer.js